import React from 'react';

import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import GuideLink from '../components/GuideLink';
import GuidePageLayout from '../components/GuidePageLayout';
import GuideSection from '../components/GuideSection';

const GuideContractOverview: React.FC = () => {
  return (
    <GuidePageLayout
      title="契約管理"
      description="契約の申請・承認・変更・解除と契約情報の管理を行う機能です。新規契約の申請から承認プロセス、チェックリスト運用、テンプレート設定まで、契約ライフサイクル全体を管理します。管理者・管理部門・課長が操作可能です。"
    >
      <GuideSection title="ガイド一覧">
        <Stack spacing={1.5}>
          <Stack spacing={0.5}>
            <GuideLink to="contract/new-request">新規契約を申請する</GuideLink>
            <Typography variant="caption" color="text.secondary" sx={{ pl: 3 }}>
              新規契約の申請を作成・提出します。
            </Typography>
          </Stack>
          <Stack spacing={0.5}>
            <GuideLink to="contract/change-terminate">契約内容の変更・解除を申請する</GuideLink>
            <Typography variant="caption" color="text.secondary" sx={{ pl: 3 }}>
              既存契約の変更申請や解除申請を行います。
            </Typography>
          </Stack>
          <Stack spacing={0.5}>
            <GuideLink to="contract/request-manage">契約申請の修正・対応・取消を行う</GuideLink>
            <Typography variant="caption" color="text.secondary" sx={{ pl: 3 }}>
              申請済みの契約申請を修正・承認対応・取消します。
            </Typography>
          </Stack>
          <Stack spacing={0.5}>
            <GuideLink to="contract/comment">契約申請にコメントする</GuideLink>
            <Typography variant="caption" color="text.secondary" sx={{ pl: 3 }}>
              契約申請に対してコメントを投稿・確認します。
            </Typography>
          </Stack>
          <Stack spacing={0.5}>
            <GuideLink to="contract/duplicate">契約申請を複製する</GuideLink>
            <Typography variant="caption" color="text.secondary" sx={{ pl: 3 }}>
              既存の申請内容をコピーし、メンバーだけ変更して一括作成します。
            </Typography>
          </Stack>
          <Stack spacing={0.5}>
            <GuideLink to="contract/search">契約・契約申請を検索する</GuideLink>
            <Typography variant="caption" color="text.secondary" sx={{ pl: 3 }}>
              条件を指定して契約や契約申請を検索・絞り込みます。
            </Typography>
          </Stack>
          <Stack spacing={0.5}>
            <GuideLink to="contract/checklist">チェックリストの操作・管理</GuideLink>
            <Typography variant="caption" color="text.secondary" sx={{ pl: 3 }}>
              契約申請時のチェックリストを操作・設定します。
            </Typography>
          </Stack>
          <Stack spacing={0.5}>
            <GuideLink to="contract/template">テンプレート（自由項目）を管理する</GuideLink>
            <Typography variant="caption" color="text.secondary" sx={{ pl: 3 }}>
              申請フォームのテンプレート項目を設定・管理します。
            </Typography>
          </Stack>
        </Stack>
      </GuideSection>
    </GuidePageLayout>
  );
};

export default GuideContractOverview;
